<template>
  <div class="option-list">
    <label
      v-for="option in options"
      :key="option.key"
      :class="['option-item', { 'is-selected': isSelected(option.key), 'is-disabled': disabled || isOptionDisabled(option.key) }]"
    >
      <CheckboxControl
        v-if="multiple"
        :checked="isSelected(option.key)"
        :disabled="disabled || isOptionDisabled(option.key)"
        @change="toggle(option.key)"
      />
      <input
        v-else
        type="radio"
        :name="name"
        :value="option.key"
        :checked="isSelected(option.key)"
        :disabled="disabled || isOptionDisabled(option.key)"
        @change="toggle(option.key)"
      >
      <span :class="['option-label', { 'is-judgment': judgment }]">{{ optionMarker(option) }}</span>
      <span class="option-content" v-html="optionText(option)"></span>
    </label>
  </div>
</template>

<script>
import CheckboxControl from './CheckboxControl.vue'

export default {
  name: 'OptionList',
  components: { CheckboxControl },
  props: {
    options: { type: Array, default: () => [] },
    value: { default: '' },
    multiple: { type: Boolean, default: false },
    name: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    disabledOptions: { type: Array, default: () => [] },
    judgment: { type: Boolean, default: false }
  },
  methods: {
    isSelected(key) {
      return this.multiple
        ? Array.isArray(this.value) && this.value.includes(key)
        : String(this.value ?? '') === String(key)
    },
    isOptionDisabled(key) {
      return this.disabledOptions.map(String).includes(String(key))
    },
    toggle(key) {
      if (this.disabled || this.isOptionDisabled(key)) return
      if (!this.multiple) {
        this.$emit('input', key)
        return
      }
      const next = Array.isArray(this.value) ? [...this.value] : []
      const index = next.indexOf(key)
      if (index >= 0) next.splice(index, 1)
      else next.push(key)
      this.$emit('input', next)
    },
    judgmentText(option) {
      const content = String(option && option.content !== undefined ? option.content : '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
      const values = [content, String(option && option.key !== undefined ? option.key : '')].map(item => item.toLowerCase())
      if (values.some(item => ['true', '1', 'yes', '正确', '对', '是'].includes(item))) return '正确'
      if (values.some(item => ['false', '0', 'no', '错误', '错', '否'].includes(item))) return '错误'
      return content || '判断选项'
    },
    optionMarker(option) {
      if (!this.judgment) return option.key
      return this.judgmentText(option) === '正确' ? '✓' : '×'
    },
    optionText(option) {
      return this.judgment ? this.judgmentText(option) : option.content
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/tokens';
.option-list { display: grid; gap: 12px; }
.option-item { display: flex; align-items: center; gap: 12px; padding: 12px 14px; border: 1px solid $color-border; border-radius: var(--radius-md); background: $color-surface; cursor: pointer; transition: 0.2s ease; }
.option-item:hover:not(.is-disabled), .option-item.is-selected { border-color: rgba($color-primary, 0.55); background: $color-primary-light; box-shadow: 0 0 0 2px rgba($color-primary, 0.07); }
.option-item.is-disabled { cursor: not-allowed; opacity: 0.55; }
input[type='radio'] { appearance: none; position: relative; display: inline-grid; width: 20px; height: 20px; flex: 0 0 20px; margin: 0; padding: 0; border: 2px solid $color-border-dark; border-radius: 50%; background: $color-surface; cursor: pointer; }
input[type='radio']::before { position: absolute; top: 50%; left: 50%; width: 8px; height: 8px; border-radius: 50%; background: $color-primary; content: ''; transform: translate(-50%, -50%) scale(0); transform-origin: center; transition: transform 0.16s ease; }
input[type='radio']:checked { border-color: $color-primary; box-shadow: 0 0 0 3px rgba($color-primary, 0.1); }
input[type='radio']:checked::before { transform: translate(-50%, -50%) scale(1); }
input[type='radio']:focus-visible { outline: none; box-shadow: 0 0 0 4px rgba($color-primary, 0.16); }
.option-label { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; flex: 0 0 auto; border-radius: 50%; background: $color-background; color: $color-text-secondary; font-weight: 800; }
.option-label.is-judgment { font-size: 18px; }
.is-selected .option-label { background: rgba($color-primary, 0.12); color: $color-primary; }
.option-content { min-width: 0; flex: 1; color: $color-text-primary; word-break: break-word; }
</style>
